import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import Button from '~/components/Button';
import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { ADD_INVOICE_ROUTE, BILLING_ROUTE } from '~/constants/routes';
import { useUserLimits } from '~/hooks/useUserLimits';
import InvoiceIcon from '~/icons/InvoiceIcon';
import { analytics, ANALYTICS_EVENTS } from '~/services/analyticsService';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const IconWrapper = styled.div`
  min-width: 104px;
  min-height: 104px;
  max-width: 104px;
  max-height: 104px;
  border-radius: 8px;
  background-color: #f7f5ff;
`;

const EmptyInvoiceList = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const { canCreateInvoice } = useUserLimits();

  const handleAddInvoice = () => {
    analytics.capture(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      screen_name: 'Invoices',
      button_name: 'Create Invoice',
      button_id: 'create_invoice',
      section: 'Empty View',
    });

    if (canCreateInvoice) {
      navigate(ADD_INVOICE_ROUTE);
    } else {
      navigate(`${BILLING_ROUTE}?ref=invoices`);
    }
  };

  return (
    <div className="v-center">
      <Gap t={60} />
      <IconWrapper className="center">
        <InvoiceIcon size={42} fill="var(--t-black)" />
      </IconWrapper>
      <Gap t={32} />
      <Text size={isDesktop ? 'md' : 'smd'} className="bold">
        No invoices found
      </Text>
      <Gap t={24} />
      <Text style={{ textAlign: 'center' }}>Create your first professional looking invoice right now.</Text>
      <Gap t={24} />
      <Button size="smd" onClick={handleAddInvoice}>
        Create Invoice
      </Button>
    </div>
  );
};

export default EmptyInvoiceList;
